'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEnvelope$002dDetail$002dPage$0024 from "./presto.-Envelope-Detail-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024105 from "./presto.-Presto-Router$$anon$105.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dId$0024 from "./presto.types$-Envelope-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$104() {
  this.bcy = null;
  this.bcq = null;
  this.bcr = false;
  this.bcz = null;
  this.bcA = false;
  this.bcD = null;
  this.bcw = null;
  this.bcx = false;
  this.bcs = null;
  this.bct = false;
  this.bcu = null;
  this.bcv = false;
  this.bcB = false;
  this.bcC = false;
  this.bcy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcD = "EnvelopeDetailPage";
}
export { $c_Lpresto_PrestoRouter$$anon$104 as $c_Lpresto_PrestoRouter$$anon$104 };
$p = $c_Lpresto_PrestoRouter$$anon$104.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$104;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$104() {
}
export { $h_Lpresto_PrestoRouter$$anon$104 as $h_Lpresto_PrestoRouter$$anon$104 };
$h_Lpresto_PrestoRouter$$anon$104.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bcy;
});
$p.M = (function() {
  if ((!this.bcr)) {
    this.bcq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcr = true;
  }
  return this.bcq;
});
$p.O = (function() {
  if ((!this.bcA)) {
    this.bcz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bcA = true;
  }
  return this.bcz;
});
$p.E = (function() {
  return this.bcD;
});
$p.t = (function() {
  if ((!this.bcx)) {
    this.bcw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bcx = true;
  }
  return this.bcw;
});
$p.N = (function() {
  if ((!this.bct)) {
    this.bcs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dId$0024.$m_Lpresto_types$EnvelopeId$().v9(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bct = true;
  }
  return this.bcs;
});
$p.Q = (function() {
  if ((!this.bcv)) {
    this.bcu = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024105.$c_Lpresto_PrestoRouter$$anon$105();
    this.bcv = true;
  }
  return this.bcu;
});
$p.v = (function() {
  if ((!this.bcC)) {
    this.bcB = false;
    this.bcC = true;
  }
  return this.bcB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee628) => ((p) => \u03b4scrutinee628.cFv(p)))($j_presto$002e$002dEnvelope$002dDetail$002dPage$0024.$m_Lpresto_EnvelopeDetailPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$104 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$104, "presto.PrestoRouter$$anon$104", ({
  NB: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$104 as $d_Lpresto_PrestoRouter$$anon$104 };
//# sourceMappingURL=presto.-Presto-Router$$anon$104.js.map
